import { DoNotContactReason } from 'graphql/bindings/AdminBindings'

export const doNotContactReasonDisplayName = (reason: DoNotContactReason): string => {
  switch (reason) {
    case DoNotContactReason.IsUnsubscribedFromDealRelatedEmails:
      return 'Unsubscribed from deal emails.'
    case DoNotContactReason.HasIntermediary:
      return 'Contact through intermediary.'
    case DoNotContactReason.IsHighSensitivity:
      return 'Contact through Forge owner.'
    case DoNotContactReason.IsInRestrictedLocation:
      return 'Country restricted.'
    case DoNotContactReason.IsForgeDeclined:
      return 'Forge declined'
  }
}

const orderOfDoNotContactReasons = [
  DoNotContactReason.IsForgeDeclined,
  DoNotContactReason.IsInRestrictedLocation,
  DoNotContactReason.IsUnsubscribedFromDealRelatedEmails,
  DoNotContactReason.IsHighSensitivity,
  DoNotContactReason.HasIntermediary,
]

export const sortDoNotContactReasons = (reasons: DoNotContactReason[]): DoNotContactReason[] =>
  reasons.slice().sort((a, b) => orderOfDoNotContactReasons.indexOf(a) - orderOfDoNotContactReasons.indexOf(b))

export interface DoNotContactFormProps {
  editSection?: 'forge_declined' | 'country' | 'sensitivity'
  highlightDNCFields?: boolean
}

export const doNotContactCountries: Array<string | null> = ['CH']
